import { api } from "@/services/api"
import { useMutation } from "@tanstack/react-query"
import type { UpdateFlashcardParams } from "@/services/api/odin/activities/flashcards/update"
import { toast } from "sonner"

export function useUpdateFlashcard() {
  return useMutation({
    mutationKey: ["update-flashcard"],
    mutationFn: ({ id, index, payload }: UpdateFlashcardParams) =>
      api.odin.activities.flashcards.update({ id, index, payload }),
    onSuccess: () => {
      toast.success("Actividad editada con éxito")
    },
    onError: () => {
      toast.error(
        "¡Ups! No se pudo editar la actividad. Intentalo de nuevo y, si el error persiste, contactanos.",
      )
    },
  })
}
